export default "<p>signup works!</p>\n"